import React from 'react'
import { Snackbar as MuiSnackbar, SnackbarProps } from '@material-ui/core'
import AppEnv from 'src/utils/appenv'

interface ISnackbarProps extends SnackbarProps {
    /** shows an action to click, so the snackbar stays twice as long */
    actionable?: boolean
    /** keeps the snackbar open until it closes another way */
    pending?: boolean
}

/** A snackbar that closes after APP_SNACKBAR_TIMEOUT. */
const Snackbar = ({ actionable, pending, ...props }: ISnackbarProps): JSX.Element => {
    const timeout = parseInt(AppEnv.APP_SNACKBAR_TIMEOUT, 10)

    return <MuiSnackbar
        autoHideDuration={pending ? null : timeout * (actionable ? 2 : 1)}
        {...props} />
}

export default Snackbar
